import { render, staticRenderFns } from "./article-section.vue?vue&type=template&id=22791433"
import script from "./article-section.vue?vue&type=script&lang=js"
export * from "./article-section.vue?vue&type=script&lang=js"
import style0 from "./article-section.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports